import axios from 'axios';
import React, { useRef, useState } from 'react';
import { useAlert } from 'react-alert';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { BsCheck } from 'react-icons/bs';
import { FaUserCheck } from 'react-icons/fa6';
import { IoMdClose } from 'react-icons/io';
import { IoCloudUpload } from 'react-icons/io5';
import { BASE_URL } from '../../insightConfig/insightConfig';
import '../CurrentPage/CategoryButton.css';
import "../CurrentPage/Current.css";
import '../Settings/Setting.js';
import HomePageText from './child_components/HomePageText.js';
import IDPDownloads from './child_components/IDPDownloads.js';
import { useNavigate } from 'react-router-dom';

function InterviewGuidance() {
    const userData = JSON.parse(localStorage.getItem('IGP_UserData'));
    const [page, setPage] = useState('login');
    const [news, setNews] = useState([]);
    const [modalBox, setModalBox] = useState(false);
    const [activeButton, setActiveButton] = useState('homepage'); //Track active button
    const [categories, setCategories] = useState([{ Category: "Book Your Slot" }, { Category: "IGP Classes" }, { Category: "Downloads" }]); // Track categories
    const [fileUploading1, setFileUploading1] = useState(false);
    const [fileUploading2, setFileUploading2] = useState(false);
    const initialSignupData = { Name: "", DOB: "", EmailId: "", MobileNo: "", UPSCRollNo: "", InterviewDate: "", Password: "", Daf1: "", Daf2: "" }
    const initialLoginData = { EmailId: "", Password: "" }
    const [loginData, setLoginData] = useState(initialLoginData);
    const [signupData, setSignupData] = useState(initialSignupData);
    console.log(loginData);
    const alert = useAlert();
    const navigate = useNavigate();

    const fileRef1 = useRef(null);
    const fileRef2 = useRef(null);











    // useEffect(() => {
    //     if (module == 'news') {
    //         axios.get(BASE_URL + `/app/getNewsCategories`).then((response) => {
    //             setCategories(response.data.data);
    //             setCategoryId(response.data.data[0].Sn)

    //         }).catch((error) => {
    //             console.log(error)
    //         })
    //     } else {
    //         axios.get(BASE_URL + `/app/getBlogCategories`).then((response) => {
    //             setCategories(response.data.data);
    //             setCategoryId(response.data.data[0].Sn)
    //         }).catch((error) => {
    //             console.log(error)
    //         })
    //     }

    // }, []);

    const handleClick = (Category) => {
        setActiveButton(Category?.toLowerCase()); // Set the active button
        if (Category == 'Register Now') {
            setPage('register');
            setModalBox(true);
        }
    }

    const handleSummit = () => {
        if (page === 'register') {
            if (!signupData.Name || !signupData.DOB || !signupData.EmailId || !signupData.MobileNo || !signupData.UPSCRollNo || !signupData.InterviewDate || !signupData.Password) {
                alert.error("Please fill all the fields")
                return
            }
            if (!signupData.Daf1 || !signupData.Daf2) {
                alert.show("Please upload all the files", {
                    position: 'top center',
                    timeout: 2000,
                })
                return
            }
            console.log(signupData)

            console.log(signupData);
            axios.post(`${BASE_URL}/igp/register`, { ...signupData })
                .then(response => {
                    console.log('Registration successful:', response.data);
                    setSignupData(initialSignupData);
                    setPage('login');
                    alert.show("Registration successful, Please login with your credentials")
                    // Handle success (e.g., show a success message, redirect, etc.)
                })
                .catch(error => {
                    console.error('Error during registration:', error);
                    // Handle error (e.g., show an error message)
                });
        } else {
            console.log(loginData);
            if (!loginData.EmailId || !loginData.Password) {
                alert.error("Please fill all the fields")
                return
            }
            axios.post(`${BASE_URL}/igp/login`, loginData)
                .then(response => {
                    console.log('Login successful:', response.data);
                    localStorage.setItem('IGP_UserData', JSON.stringify(response.data.data))
                    setLoginData(initialLoginData);
                    setModalBox(false);
                    alert.show("Login successful")
                    // Handle success (e.g., show a success message, redirect, etc.)
                })
                .catch(error => {
                    console.error('Error during login:', error);
                    // Handle error (e.g., show an error message)
                });
        }
    }

    const selectedFileHandler = async (fileType, file) => {
        try {
            const formData = new FormData();
            if (fileType === 'Daf1') {
                setFileUploading1(true);
                formData.append('uploadedFile', file, file.name);
            } else if (fileType === 'Daf2') {
                setFileUploading2(true)
                formData.append('uploadedFile', file, file.name);
            }
            const response = await axios.post(BASE_URL + '/uploadFile', formData);
            console.log(response);
            setSignupData({ ...signupData, [fileType]: response.data.imagePath });
        } catch (error) {
            console.log(error);
            alert.error(error.response.data.message)

        } finally {
            fileRef1.current.value = null;
            fileRef2.current.value = null;
            setTimeout(() => {
                setFileUploading1(false);
                setFileUploading2(false);
            }, 1000);

        }

    }
    const handleDashboardClick = () => {
        if (!userData?.Sn) {
            setPage('register');
            setModalBox(true);
        } else {
            navigate('/StudentDashboard');
        }
    }
    console.log(activeButton);
    return (
        <>
            <div className='CurrentAffairs-background'>
                <div className='current-main-box'>
                    <h1>Interview Guidance Programme »»</h1>
                    <div className='buttontab-background'>
                        <div className='p-3'>
                            <div className="buttontab-Container">
                                <button className={`btn btn-margin bgtab-white`} type="button" onClick={handleDashboardClick}>
                                    {!userData?.Sn ? "Register Now" : "Dashboard"}
                                </button>
                                {categories.map((obj, index) => (
                                    <button
                                        key={index}
                                        className={`btn btn-margin ${activeButton == obj.Category.toLowerCase() ? 'activebuttontab' : "bgtab-white"}`}
                                        onClick={() => handleClick(obj.Category)}
                                        type="button">{obj.Category}</button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="">
                {activeButton == 'homepage' && <HomePageText />}
                {activeButton == 'downloads' && <IDPDownloads />}

            </section>

            <Modal className="" show={modalBox} onHide={setModalBox} dialogClassName="igp_signup-modal" backdrop="static"
                keyboard={false} style={{ zIndex: "9999" }}>
                <Modal.Header className="position-relative justify-content-center py-2" style={{ backgroundImage: 'linear-gradient(to right, #9b0000, #6d0761)' }}>
                    <Modal.Title className="w-100 text-center text-white m-0 fw-bold " style={{ letterSpacing: "3px" }}>{page == 'register' ? 'REGISTER FOR I.G.P' : 'LOGIN FOR I.G.P'}</Modal.Title>
                    <Button variant="" onClick={() => setModalBox(false)} style={{ background: 'none', border: 'none', position: 'absolute', top: '0.3rem', right: '1rem' }}>
                        <IoMdClose size={32} color="white" />
                    </Button>
                </Modal.Header>


                <Modal.Body className='bg-light'>
                    <div className="container-fluid">
                        {
                            page === 'register' ?
                                <div className="">


                                    <div className='d-md-flex justify-content-center align-items-center '>
                                        <div className="mb-3 col-md-6 px-2">
                                            <label htmlFor="fullName" className="form-label fw-semibold">Full Name</label>
                                            <input
                                                style={{ textDecoration: "capitalize" }}
                                                type="text"
                                                className="form-control fullName"
                                                id="fullName"
                                                placeholder='Full Name'
                                                aria-describedby="emailHelp"
                                                value={signupData.Name}
                                                onChange={(e) => setSignupData({ ...signupData, Name: e.target.value })}
                                            />
                                        </div>
                                        <div className="mb-3 col-md-6 px-2">
                                            <label htmlFor="email" className="form-label fw-semibold">Date of birth</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                id="email"
                                                placeholder='Your Email-ID'
                                                value={signupData.DOB}
                                                onChange={(e) => setSignupData({ ...signupData, DOB: e.target.value })}
                                            />
                                        </div>


                                    </div>

                                    <div className='d-md-flex justify-content-center align-items-center'>
                                        <div className="mb-3 col-md-6 px-2 ">
                                            <label htmlFor="email" className="form-label fw-semibold">Email ID</label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                id="email"
                                                placeholder='Your Email-ID'
                                                value={signupData.EmailId}
                                                onChange={(e) => setSignupData({ ...signupData, EmailId: e.target.value })}
                                            /* value={email} */
                                            /* onChange={(e) => setEmail(e.target.value.toLowerCase())} */
                                            />
                                        </div>
                                        <div className="mb-3 col-md-6 px-2">
                                            <label htmlFor="phoneNo" className="form-label fw-semibold">Phone No</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                id="phoneNo"
                                                placeholder='Mobile No'
                                                value={signupData.MobileNo}
                                                onChange={(e) => setSignupData({ ...signupData, MobileNo: e.target.value })}
                                            /* value={contact} */
                                            /* onChange={(e) => setContact(e.target.value)} */
                                            />
                                        </div>
                                    </div>
                                    <div className='d-md-flex justify-content-center align-items-center'>
                                        <div className="mb-3 col-md-6 px-2">
                                            <label htmlFor="phoneNo" className="form-label fw-semibold">UPSC Roll No.</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                id="phoneNo"
                                                placeholder='UPSC Roll No.'
                                                value={signupData.UPSCRollNo}
                                                onChange={(e) => setSignupData({ ...signupData, UPSCRollNo: e.target.value })}
                                            /* value={contact} */
                                            /* onChange={(e) => setContact(e.target.value)} */
                                            />
                                        </div>
                                        <div className="mb-3 col-md-6 px-2">
                                            <label htmlFor="email" className="form-label fw-semibold">Date of Interview</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                id="email"
                                                placeholder=''
                                                value={signupData.InterviewDate}
                                                onChange={(e) => setSignupData({ ...signupData, InterviewDate: e.target.value })}
                                            /* value={email} */
                                            /* onChange={(e) => setEmail(e.target.value.toLowerCase())} */
                                            />
                                        </div>

                                        {/* <div className="mb-3 col-md-6 px-2">
                                    <label htmlFor="password" className="form-label">Password</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="password"
                                        placeholder='Password'
                                   value={password} 
                                   onChange={(e) => setPassword(e.target.value)}
                                    />
                                </div> */}
                                    </div>
                                    <div className='d-md-flex justify-content-center align-items-center'>
                                        <div className="mb-3 col-md-6 px-2">
                                            <label htmlFor='file1' className="form-label fw-semibold d-block"><FaUserCheck className='me-2' />DAF1</label>
                                            <label htmlFor="file1" style={{ backgroundColor: "#f0f0f0", padding: "10px", borderRadius: "6px", cursor: "pointer" }} className="custom-input w-75 "> <IoCloudUpload className='upload-icon1 me-1' size={23} />Upload File</label>
                                            <input ref={fileRef1} id="file1" style={{ display: "none" }} type="file" accept=".pdf" onChange={(event) => selectedFileHandler('Daf1', event.target.files[0])} />
                                            {fileUploading1 ? <Spinner className='' variant="info" /> : (signupData.Daf1) && <BsCheck style={{ cursor: "pointer" }} className='ms-2 bg-gray' color='green' size={40} />}
                                        </div>
                                        <div className="mb-3 col-md-6 px-2">
                                            <label htmlFor='file2' className="form-label fw-semibold d-block"><FaUserCheck className='me-2' />DAF2</label>
                                            <label for="file2" style={{ backgroundColor: "#f0f0f0", padding: "10px", borderRadius: "6px", cursor: "pointer" }} className="custom-input w-75"> <IoCloudUpload className='upload-icon1 me-1' size={23} />Upload File</label>
                                            <input ref={fileRef2} id="file2" style={{ display: "none" }} accept=".pdf" type="file" onChange={(event) => selectedFileHandler('Daf2', event.target.files[0])} />
                                            {fileUploading2 ? <Spinner className='' variant="info" /> : (signupData.Daf2) && <BsCheck style={{ cursor: "pointer" }} className='ms-2 bg-gray' color='green' size={40} />}
                                        </div>

                                    </div>
                                    <div className='d-md-flex justify-content-center align-items-center'>
                                        <div className="mb-3 col-md-6 px-2">
                                            <label htmlFor="password" className="form-label fw-semibold d-block">Password</label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                id="password"
                                                placeholder='Password'
                                                value={signupData.Password}
                                                onChange={(e) => setSignupData({ ...signupData, Password: e.target.value })}
                                            // value={password}
                                            // onChange={(e) => setPassword(e.target.value)}
                                            />
                                        </div>
                                        <div className="mb-3 col-md-6 px-2">

                                        </div>
                                    </div>
                                    <div className="d-flex flex-column justify-content-center align-items-center">
                                        <div className="w-100" style={{ maxWidth: "500px" }}>
                                            <button
                                                className="btn btn-primary login-btn w-100 py-2 border-0"
                                                type="button"
                                                onClick={handleSummit}
                                            >
                                                REGISTER
                                            </button>
                                        </div>
                                    </div>
                                </div>


                                :

                                <div className="d-flex justify-content-center align-items-center py-3">
                                    <div className="w-100" style={{ maxWidth: "500px" }}>
                                        <div className="mb-3 px-2">
                                            <label htmlFor="email" className="form-label fw-semibold">Email ID</label>
                                            <input type="email" className="form-control" id="email" placeholder="Your Email-ID" value={loginData.EmailId} onChange={(e) => setLoginData({ ...loginData, EmailId: e.target.value })} />
                                        </div>
                                        <div className="mb-3 px-2">
                                            <label htmlFor="password" className="form-label fw-semibold">Password</label>
                                            <input type="password" className="form-control" id="password" placeholder="Password" value={loginData.Password} onChange={(e) => setLoginData({ ...loginData, Password: e.target.value })} />
                                        </div>
                                        <div className="d-flex justify-content-center align-items-center mt-5 px-2">
                                            <div className="w-100" style={{ maxWidth: "500px" }}>
                                                <button className="btn btn-primary login-btn w-100 py-2 border-0" onClick={handleSummit}>Login</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                        }

                    </div>
                </Modal.Body>
                <Modal.Footer className='bg-light d-flex justify-content-center align-items-center p-0 m-1'>
                    {
                        page === 'register' ?
                            <span className='fw-semibold text-dark me-2'>
                                Already registered for IGP?
                            </span>
                            :
                            <span className='fw-semibold text-dark me-2'>
                                Not registered yet?
                            </span>
                    }
                    <Button
                        variant="light"
                        className='btn btn-sm'
                        style={{ backgroundColor: "#6e1158", color: "white", fontWeight: "600" }}
                        onClick={() => setPage(page === 'register' ? 'login' : 'register')}
                    >
                        {page === 'register' ? "Login" : "Register Now"}
                    </Button>
                </Modal.Footer>

            </Modal>


        </>
    );
}

export default InterviewGuidance;
